import axios from 'axios';

const statusData = { type: 'success', status: '200', msg: '' };
const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

export const requestAutoCompleteList = async text => {
  let data = { status: statusData, data: {} };

  try {
    const setParam = {
      speech: text,
      label: 'yongin_autocomplete',
      middle: true,
    };
    const res = await axios.post(`/${domainUrlParam}/autocomplete`, setParam);

    data = { ...data, data: res.data };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};

export const requestDMPost = async setParam => {
  let getData = { status: statusData, data: {} };

  try {
    const resp = await axios.post(`/${domainUrlParam}/dialogue`, setParam);
    getData = { ...getData, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

// 2024.7.22 사용자 편의성 조사 출력
export const requestUSAPost = async setParam => {
  let getData = { status: statusData, data: {} };

  try {
    const resp = await axios.post(`/${domainUrlParam}/usability`, setParam);
    getData = { ...getData, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

export const requestQuality = async () => {
  let getData = { status: statusData, data: {} };
  try {
    const resp = await axios.post(`/${domainUrlParam}/quality`);
    getData = { ...getData, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    getData = { ...getData, status: statusSet };
  }

  return getData;
};

export const requestTypeInfo = async setParam => {
  let data = { status: statusData, data: {} };
  try {
    const resp = await axios.post(`/${domainUrlParam}/getTypeInfo`, setParam);
    data = { ...data, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    data = { ...data, status: statusSet };
  }
  return data;
};

export const requestUrlEvent = async setParam => {
  let data = { status: statusData, data: {} };
  try {
    const resp = await axios.post(`/${domainUrlParam}/insertUrlEvent`, setParam);
    data = { ...data, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    data = { ...data, status: statusSet };
  }
  return data;
};

export const requestSearch = async setParam => {
  let data = { status: statusData, data: {} };
  try {
    const resp = await axios.post(`/${domainUrlParam}/yonginSearch`, setParam);
    data = { ...data, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    data = { ...data, status: statusSet };
  }
  return data;
};
